import {useEffect} from 'react';

import {appRoute} from '../../../../app-route';
import {Meta} from '../../../../component/meta/meta';
import {BreadCrumbs} from '../../../../layout/bread-crumbs/bread-crumbs';
import {Page} from '../../../../layout/page/page';
import {PageHeader} from '../../../../layout/page-header/page-header';
import {Spinner} from '../../../../layout/spinner/spinner';
import {Locale} from '../../../../provider/locale/locale';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {postCompanySelectorCompanySchema} from '../../../../service/feature-companies/feature-companies-api-type';
import {CompaniesSelectorFeatureEnum} from '../../../../service/feature-companies/feature-companies-const';
import {useCompaniesSelector} from '../../../../service/feature-companies/feature-companies-hook';
import {PostSelectorCompanyType} from '../../../../service/feature-companies/feature-companies-type';
import {usePost} from '../../../../service/posts/posts-hooks';
import {PostFormFieldsEnum, PostFormModeEnum} from '../../../../service/posts/posts-types';
import {useUrl} from '../../../../util/url-hook/url-hook';
import {PostForm} from '../post-form/post-form';
import {getPostFormInitialValues, POST_FORM_EMPTY_VALUES} from '../post-form/posts-form-helper';
import * as styles from '../posts.scss';

export function CreatePost(): JSX.Element {
    const {postsManagement} = appRoute;

    const {queries} = useUrl();

    const {postId} = queries;

    const {data: post, isLoading} = usePost(Number(postId));

    const {getLocalizedString} = useLocale();

    const companiesSelector = useCompaniesSelector<PostSelectorCompanyType>({
        feature: CompaniesSelectorFeatureEnum.Posts,
        resourceId: postId || null,
        companySchema: postCompanySelectorCompanySchema,
        selectorId: post?.[PostFormFieldsEnum.SelectorId],
    });

    const {initializeSelector, selectorId} = companiesSelector;

    useEffect(() => {
        if (!postId) {
            initializeSelector();
        }
    }, [initializeSelector, postId]);

    return (
        <Page mainClassName={styles.PostsFormPageContainer}>
            <Meta title={getLocalizedString('CATEGORY_NAME__CREATE_POSTS')} />

            <BreadCrumbs
                list={[
                    {path: postsManagement.path, titleLangKey: 'CATEGORY_NAME__POSTS'},
                    {path: '', titleLangKey: 'CATEGORY_NAME__CREATE_POSTS'},
                ]}
            />
            <PageHeader>
                <Locale stringKey="POSTS__CREATE_POST__HEADER" />
            </PageHeader>

            {isLoading && !Number.isNaN(Number(postId)) && <Spinner position="absolute" />}

            {post ? (
                <PostForm
                    companiesSelector={companiesSelector}
                    formMode={PostFormModeEnum.Copy}
                    initialValues={{
                        ...getPostFormInitialValues(post),
                        [PostFormFieldsEnum.Id]: Number(postId),
                        [PostFormFieldsEnum.Name]: `Copy ${post[PostFormFieldsEnum.Name]}`,
                    }}
                />
            ) : (
                selectorId && (
                    <PostForm
                        companiesSelector={companiesSelector}
                        formMode={PostFormModeEnum.New}
                        initialValues={{
                            ...POST_FORM_EMPTY_VALUES,
                            [PostFormFieldsEnum.SelectorId]: selectorId,
                        }}
                    />
                )
            )}
        </Page>
    );
}
